import { ColorSchemeTypes } from "../../types/ColorScheme"
import normalizeImage, { NormalizedImageData, RawImageData } from "../base/ImageBase"

export interface ImageComparisonProps {
  id: number
  sectionId?: string
  colorScheme: ColorSchemeTypes
  beforeImage: RawImageData
  afterImage: RawImageData
  beforeLabel?: string
  afterLabel?: string
  initialPosition?: number
}

export interface NormalizedImageComparisonProps {
  beforeImage: NormalizedImageData
  afterImage: NormalizedImageData
  beforeLabel?: string
  afterLabel?: string
  initialPosition?: number
  sectionId?: string
  colorScheme: ColorSchemeTypes
}

const ImageComparison = ({
  sectionId,
  colorScheme,
  beforeImage,
  afterImage,
  beforeLabel,
  afterLabel,
  initialPosition,
  ...rest
}: ImageComparisonProps): NormalizedImageComparisonProps => {
  const normalizedData: NormalizedImageComparisonProps = {
    sectionId,
    colorScheme,
    beforeImage: normalizeImage(beforeImage),
    afterImage: normalizeImage(afterImage),
    beforeLabel,
    afterLabel,
    initialPosition,
    ...rest
  }

  return normalizedData
}

export default ImageComparison

